import { FC } from 'react';

interface DateFormatterProps {
  dateString: string;
}

const DateFormatter: FC<DateFormatterProps> = ({ dateString }) => {
  if (!dateString) return null;

  const date = new Date(dateString);
  
  // Get month abbreviation
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = monthNames[date.getMonth()];
  
  // Get day and year
  const day = date.getDate();
  const year = date.getFullYear();

  return (
    <span className="text-sm font-normal text-gray-700">
      {`${month} ${day} ${year}`}
    </span>
  );
};

export default DateFormatter;